<template>
  <div>
    <el-form ref="form" class="login_container" :model="form" :rules="rules">
      <h3 class="login_title">AMH管理后台登录</h3>
      <el-form-item prop="username">
        <el-input
          prefix-icon="el-icon-user"
          v-model="form.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          prefix-icon="el-icon-lock"
          type="password"
          v-model="form.password"
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>

      <div class="form_item">
        <el-checkbox v-model="check_account">记住账号</el-checkbox>
        <el-checkbox v-model="check_login">保持登录</el-checkbox>
      </div>

      <div class="ver">
        <Verify
          :type="3"
          @success="success"
          :showButton="false"
          :barSize="{ width: '250px', height: '40px' }"
        ></Verify>
      </div>

      <el-form-item>
        <el-button type="primary" @click="submit()" round>登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { login } from "@/api";
import Verify from "vue2-verify";
import Cookie from "js-cookie";
export default {
  data() {
    return {
      check_account: true,
      check_login: true,
      check_verify: false,
      form: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, trigger: "blur", message: "请输入用户名" },
        ],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
      },
    };
  },
  components: { Verify },
  methods: {
    submit() {
      if (!this.check_verify) {
        this.$message("请完成滑块验证");
      } else {
        //获取token
        this.$refs.form.validate((valid) => {
          if (valid) {
            login(this.form).then(({ data }) => {
              if (data.code === 200) {
                Cookie.set("token", data.data.token);
                // if (this.check_login) {
                //   Cookie.set("token", data.data.token, { expires: 7 });
                //   this.$store.commit("setMenu", data.data.menu,7);
                // } else {
                //   Cookie.set("token", data.data.token);
                //   this.$store.commit("setMenu", data.data.menu);
                // }

                //menu存入store
                this.$store.commit("setMenu", data.data.menu);
                this.$store.commit("addMenu", this.$router);
                //记住账户
                if (this.check_account) {
                  window.localStorage.setItem(
                    "accessUsername",
                    JSON.stringify(this.form.username)
                  );
                }
                //跳转后台首页
                this.$router.replace("/home");
              } else {
                this.$message.error(data.message);
              }
            });
          }
        });
      }
    },
    success() {
      this.check_verify = true;
    },
  },
  mounted() {
    let accessUsername = window.localStorage.getItem("accessUsername");
    if (accessUsername) {
      this.form.username = JSON.parse(accessUsername);
    }
    // if(Cookie.get("token")){

    // }
  },
};
</script>

<style lang="less" scoped>
div {
  touch-action: none;
  touch-action: pan-y;
}
.ver {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
}
.login_container {
  text-align: center;
  width: 100%;
  margin: 200px auto;
  .login_title {
    font-size: x-large;
    margin-bottom: 50px;
  }
  .el-input {
    width: 250px;
  }
  .el-button {
    margin-top: 20px;
    width: 250px;
  }
  .form_item {
    display: flex;
    justify-content: center;
  }
}
</style>
